export const OUTLINE_STYLES = {
  position: 'absolute',
  inset: 0,
  borderRadius: 'inherit',
  mask: 'linear-gradient(rgb(255, 255, 255) 0px, rgb(255, 255, 255) 0px) content-box exclude, linear-gradient(rgb(255, 255, 255) 0px, rgb(255, 255, 255) 0px)',
} as const;
